module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"pdp-tab-gpsr":{"headline":"Generel produktsikkerhed (GPSR)"}},"de":{"pdp-tab-gpsr":{"headline":"Allgemeine Produktsicherheit (GPSR)"}},"fr":{"pdp-tab-gpsr":{"headline":"Règlement sur la sécurité générale des produits (RSGP)"}},"nl":{"pdp-tab-gpsr":{"headline":"Algemene productveiligheid (GPSR)"}}}')
  delete Component.options._Ctor
}
